import { React, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Logo.jpeg";
import "./NavBar.css";
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const goToSection = (sectionId) => {
    navigate(`/#${sectionId}`);
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="logo-container">
        <img
          src={logo}
          alt="Jerry Madithapa Funerals Logo"
          className="logo"
          onClick={() => goToSection("home")}
        />
      </div>

      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <button onClick={() => goToSection("home")}>Home</button>
        <button onClick={() => goToSection("about")}>About</button>
        <button onClick={() => goToSection("packages")}>Packages</button>
        <button onClick={() => goToSection("gallery")}>Gallery</button>
        <button onClick={() => goToSection("contact")}>Contact</button>
      </div>

      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  );
}